/**
 * @generated SignedSource<<9363f5800e16f6dd1dfb0a76a574d3d1>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
import { FragmentRefs } from "relay-runtime";
export type automationUtils_useGetDefaultSlackMessageSendAsFragment$data = {
  readonly omscs: {
    readonly edges: ReadonlyArray<{
      readonly node: {
        readonly id: string;
      };
    }>;
  };
  readonly " $fragmentType": "automationUtils_useGetDefaultSlackMessageSendAsFragment";
};
export type automationUtils_useGetDefaultSlackMessageSendAsFragment$key = {
  readonly " $data"?: automationUtils_useGetDefaultSlackMessageSendAsFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"automationUtils_useGetDefaultSlackMessageSendAsFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "automationUtils_useGetDefaultSlackMessageSendAsFragment",
  "selections": [
    {
      "alias": "omscs",
      "args": [
        {
          "kind": "Literal",
          "name": "status",
          "value": "active"
        },
        {
          "kind": "Literal",
          "name": "viewerOnly",
          "value": true
        }
      ],
      "concreteType": "OrganizationMembershipSlackConnectionNodeConnection",
      "kind": "LinkedField",
      "name": "organizationMembershipSlackConnections",
      "plural": false,
      "selections": [
        {
          "alias": null,
          "args": null,
          "concreteType": "OrganizationMembershipSlackConnectionNodeEdge",
          "kind": "LinkedField",
          "name": "edges",
          "plural": true,
          "selections": [
            {
              "alias": null,
              "args": null,
              "concreteType": "OrganizationMembershipSlackConnection",
              "kind": "LinkedField",
              "name": "node",
              "plural": false,
              "selections": [
                {
                  "alias": null,
                  "args": null,
                  "kind": "ScalarField",
                  "name": "id",
                  "storageKey": null
                }
              ],
              "storageKey": null
            }
          ],
          "storageKey": null
        }
      ],
      "storageKey": "organizationMembershipSlackConnections(status:\"active\",viewerOnly:true)"
    }
  ],
  "type": "Organization",
  "abstractKey": null
};

(node as any).hash = "cf89282887adac3d8b156c97b560b815";

export default node;
